import React, {useState, useEffect, useRef} from 'react'
import {useSelector} from 'react-redux'
import {ProGallery } from 'pro-gallery'
import CardDetailModal from './modal/CardDetailModal'
import _ from 'lodash'
import 'pro-gallery/dist/statics/main.css';

const SetView =  (props) => {

    const [loading, setLoading] = useState('ui  dimmer')
    const [currSet, setCurrSet] = useState('')
    const [modalOpen, setModalOpen] = useState(false)
    const [imageData, setImageData] = useState([])
    const [container, setContainer] = useState({})
    const [currImg, setCurrImg] = useState()
    const cardData = useSelector(state => state.cardGrid)
    const componentRef = useRef()

    useEffect(() => { 
        let tempSet =  _.sortBy(_.filter(cardData.cardGridData, ['completeSetId', currSet]), [function(o) { return parseInt(o.cardNum)}])
        setImageData(tempSet.map(obj=> (
            { ...obj, 
                mediaUrl: 'https://ik.imagekit.io/cardGallery/'+obj.imageUrl + "?tr=h-100", 
                fileName: obj.imageUrl,
                metaData: {
                    type: 'image',
                     title: obj.imageUrl,
                     description: {
                         cardNum: obj.cardNum,
                         player: obj.player,
                         setName: obj.setName,
                         completeSetId: obj.completeSetId
                         
                     },
                    // description: 'sample-description',
                    link: {
                            url: 'https://ik.imagekit.io/cardGallery/'+obj.imageUrl + "?tr=h-100",
                            target: '_blank'
                    },
            }
            })))
      }, [currSet, cardData.cardGridData]);

      useEffect(() => {
        setContainer(
            {
                width: componentRef.current ? componentRef.current.offsetWidth : 0,
                height: componentRef.current ? componentRef.current.offsetHeight : 0
            }
        )
      }, [componentRef]);  //Tell the grid thingy to use the proper dimensions

        // The options of the gallery (from the playground current state)
        const options = {
            galleryLayout: 2,
            gallerySizeType: 'px',
            cubeType: 'fit',
            gallerySizePx: 100,
          };
      
          // The eventsListener will notify you anytime something has happened in the gallery.
          const eventsListener = (eventName, eventData) => {
              //console.log({eventName, eventData}); 
              //both of these events are triggered when you click an image
              if (eventName === 'ITEM_CLICKED' || eventName === 'ITEM_ACTION_TRIGGERED') {
                  setCurrImg({
                      imgUrl:  eventData.title,
                      cardData: eventData.description
                    })
                  console.log({eventName, eventData}); 
                  setModalOpen(true)
              }
              else { //Hovering over somethign else should trigger a modal close
                setModalOpen(false)
              }
          }

        const scrollingElement = window;

    return  (
        <div className="ui grid">
            <div className="sixteen wide column">
            <br/>
                <div id="galleryContainer" ref={componentRef} className="ui container all-features">
                    <div className={loading}>
                            <div className="ui loader"></div>
                    </div>
                    <div className="ui inverted segment">
                            <div  className="ui inverted large statistic">
                                <div className="ui inverted form">
                                    <div className="field">
                                        <label>Select a Set</label>
                                        <select className="ui search dropdown" onChange={(event) =>setCurrSet(event.target.value) }>
                                        <option>Select a Value</option>
                                        {cardData.sets.map(setItem =>
                                        <option key={setItem} value={setItem}>{setItem}</option>
                                         )};
                                        </select>
                                    </div>
                                </div>
                            </div>
                    </div>
                <CardDetailModal open={modalOpen} card={currImg}/>
                <ProGallery
                items={imageData}
                options={options}
                container={container}
                eventsListener={eventsListener}
                scrollingElement={scrollingElement}
                />
                </div>
            </div>
        </div> 
      );
}
export default SetView